import {
  renderMainLeftCell,
  renderMainRightCell,
  renderSoftLeftCell,
  renderSectionHeaderAsOfDate,
  renderRowGaps,
  renderColumnGaps
} from '../helpers';
import { textBold } from '../download-data-styles';

export const renderMorningstarFooterRow = (leftCol, rightCol) => {
  let rowString = `<tr>`;
  rowString += renderMainLeftCell(leftCol);
  rowString += renderMainRightCell(rightCol);
  rowString += `</tr>`;
  return rowString;
};

export const renderMorningstarRatingRow = rating => {
  let rowString = `<tr>`;
  rowString += renderMainLeftCell(`${rating.title}&trade;`);
  rowString += renderMainRightCell(rating.rating);
  rowString += renderColumnGaps();
  rowString += renderSoftLeftCell(`(${rating.count} funds rated)`);
  rowString += `</tr>`;
  return rowString;
};

export const morningstarRatingModule = data => {
  let moduleString = ``;
  moduleString += renderSectionHeaderAsOfDate(data.moduleHeader, data.mstarAsOfDate);
  moduleString += `<tr>`;
  moduleString += renderMainLeftCell('(5 is Highest, 1 is Lowest)', textBold);
  moduleString += `</tr>`;
  moduleString += renderRowGaps();
  data.mstarRatingsArray.forEach(rating => { moduleString += renderMorningstarRatingRow(rating); });
  moduleString += renderMorningstarFooterRow('Overall Morningstar Risk', `${data.mStarRiskRatingOverallTxt} ${data.mStarRiskRatingOverall}`);
  moduleString += renderMorningstarFooterRow(data.mstarCategoryLabel, data.mStarCategory);
  moduleString += `</tr>`;
  moduleString += renderRowGaps(2);
  return moduleString;
};
